import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

export const usePresenter = () => {

  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');

  // Забор
  const dzValueHandler = (dzValue: number | null) => {
    console.log('fence/set-dz-value', dzValue)
    dispatch('fence/set-dz-value', { dzValue }); // ДЗ - длина забора
  };
  const vzValueHandler = (vzValue: string) => {
    dispatch('fence/set-vz-value', { vzValue }); // ВЗ - высота забора
  };
  const tpValueHandler = (tpValue: string) => {
    dispatch('fence/set-tp-value', { tpValue }); // ТП - тип периметра
  };
  const rsValueHandler = (rsValue: number | null) => {
    dispatch('fence/set-rs-value', { rsValue }); // РС - расстояние между столбами
  };
  const ssValueHandler = (ssValue: string) => {
    dispatch('fence/set-ss-value', { ssValue }); // сечение столба
  };
  const kvValueHandler = (kvValue: string) => {
    dispatch('fence/set-kv-value', { kvValue }); // КВ - количество ворот
  };
  const shvValueHandler = (shvValue: string) => {
    dispatch('fence/set-shv-value', { shvValue }); // ШВ - ширина ворот
  };
  const kkValueHandler = (kkValue: string) => {
    dispatch('fence/set-kk-value', { kkValue }); // КК - количество калиток
  };
  const shkValueHandler = (shkValue: string) => {
    dispatch('fence/set-shk-value', { shkValue }); // ШК - ширина калитки
  };


  const pgvValueHandler = (pgvValue: string) => {
    dispatch('fence/set-pgv-value', { pgvValue }); // параметр горизонталей вид
  };
  const pgkValueHandler = (pgkValue: string) => {
    dispatch('fence/set-pgk-value', { pgkValue }); // ПГ - параметр горизонталей количество
  };
  const kValueHandler = (kValue: string) => {
    dispatch('fence/set-k-value', { kValue }); // крепления
  };


  return {
    dzValue: fenceStore.dzValue,
    vzValue: fenceStore.vzValue,
    tpValue: fenceStore.tpValue,
    rsValue: fenceStore.rsValue,
    ssValue: fenceStore.ssValue,

    kvValue: fenceStore.kvValue,
    shvValue: fenceStore.shvValue,
    kkValue: fenceStore.kkValue,
    shkValue: fenceStore.shkValue,

    pgvValue: fenceStore.pgvValue,
    pgkValue: fenceStore.pgkValue,
    kValue: fenceStore.kValue,

    dzValueHandler,
    vzValueHandler,
    tpValueHandler,
    rsValueHandler,
    ssValueHandler,

    kvValueHandler,
    shvValueHandler,
    kkValueHandler,
    shkValueHandler,

    pgvValueHandler,
    pgkValueHandler,
    kValueHandler,
  };
};
















